import { gql } from '@apollo/client'

export const PERSONNE_UPDATE_MUTATION = gql`
  mutation PersonneUpdateTel($id: bigint!, $data: d4_personne_set_input!) {
    update_d4_personne_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      prenom
      nom
      titre
      telfixe
      telportable
      mail1
      mail2
    }
  }
`
